<template>
    <div class="w-full h-screen flex flex-col items-center justify-between">
        <div class="flex flex-wrap w-full overflow-y-scroll text-xl">
            <div class="w-full px-2 py-2 text-2xl bg-indigo-600 sticky top-0">
                <img src="../assets/autralis_white.png" class="h-6" />
            </div>
            <div class="w-full px-2 pt-2 text-2xl text-teal-800">Tasks</div>
            <div class="w-1/2 p-2 h-24">
                <div class="w-full h-full bg-teal-400 text-white rounded shadow p-2" @click="select('task-waiting')">Waiting</div>
            </div>
            <div class="w-1/2 p-2 h-24">
                <div class="w-full h-full bg-teal-400 text-white rounded shadow p-2" @click="select('task-create')">Create</div>
            </div>

            <div class="w-full px-2 pt-2 text-2xl text-teal-800">Assets</div>
            <div class="w-1/2 p-2 h-24">
                <div class="w-full h-full bg-indigo-600 text-white rounded shadow p-2" @click="select('asset-enter')">Enter</div>
            </div>
            <div class="w-1/2 p-2 h-24">
                <div class="w-full h-full bg-indigo-600 text-white rounded shadow p-2" @click="select('asset-deliver')">Deliver</div>
            </div>
            <div class="w-1/2 p-2 h-24">
                <div class="w-full h-full bg-indigo-600 text-white rounded shadow p-2" @click="select('asset-move')">Move</div>
            </div>
            <div class="w-1/2 p-2 h-24">
                <div class="w-full h-full bg-indigo-600 text-white rounded shadow p-2" @click="select('asset-service')">Service</div>
            </div>
            <div class="w-1/2 p-2 h-24">
                <div class="w-full h-full bg-indigo-600 text-white rounded shadow p-2" @click="select('asset-inventory')">Inventory</div>
            </div>
            <div class="w-full px-2 pt-2 text-2xl text-teal-800">Documents</div>
            <div class="w-1/2 p-2 h-24">
                <div class="w-full h-full bg-indigo-600 text-white rounded shadow p-2" @click="select('not-active')">Enter</div>
            </div>
            <div class="w-1/2 p-2 h-24">
                <div class="w-full h-full bg-indigo-600 text-white rounded shadow p-2" @click="select('not-active')">Deliver</div>
            </div>
            <div class="w-1/2 p-2 h-24">
                <div class="w-full h-full bg-indigo-600 text-white rounded shadow p-2" @click="select('not-active')">Move</div>
            </div>
            <div class="w-1/2 p-2 h-24">
                <div class="w-full h-full bg-indigo-600 text-white rounded shadow p-2" @click="select('not-active')">Inventory</div>
            </div>
            <div class="w-full px-2 pt-2 text-2xl text-teal-800">Common</div>
            <div class="w-1/2 p-2 h-24">
                <div class="w-full h-full bg-yellow-300 text-yellow-600 rounded shadow p-2" @click="select('history')">History</div>
            </div>
            <div class="w-1/2 p-2 h-24">
                <div class="w-full h-full bg-yellow-300 text-yellow-600 text-white rounded shadow p-2" @click="select('not-active')">System</div>
            </div>
        </div>
        <div class="py-2 border-t border-gray-200 bg-white w-full text-center">
            <button @click="logout" class="bg-gray-200 mb-2 p-2 px-16 text-indigo-700 rounded-lg focus:bg-indigo-200 font-bold">Log out</button>
        </div>
    </div>
</template>

<script>
    import {clearContext} from "../library/session";

    export default {
        name: "Home",
        methods: {
            logout() {
                clearContext();
                this.$emit("select-main", "login");
            },
            select(item) {
                this.$emit("select-main", item);
            }
        }
    }
</script>

<style scoped>

</style>